
import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../config/hooks';
import { getAgreementByIdApi, updateAgreementApi } from '../../slices/salesSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import EditIcon from '../../assets/Icons/EditIcon';
import ServiceAgreementForm from './ServiceAgreementForm';
import Popup from '../../components/popup/Popup';
import useSalesDropdown from '../../utils/dropdown-options/useSalesDropdown';
import Pdf from '../../components/pdf-viewer/Pdf';
import { baseUrl } from '../../constant';
import PdfView from './PdfView';
import FileIcon from '../../assets/Icons/FileIcon';
import DocToImageViewer from '../../components/pdf-viewer/DocToImageViewer';
import { toast } from 'sonner';
import uploadContent from '../../utils/upload-content/uploadContent';
import { spacing } from 'react-select/dist/declarations/src/theme';


const AgreementDetail = ({ clientId, agreementId, agreementPopupHandler}) => {
  const [agreementData, setAgreementData] = useState(null);
  const {session}=useAppSelector((state)=>state.login)
  const {AgCTCRange,AgFreeReplacementPeriod,AgPaymentSchedule,AgPaymentTerms,AgProfileValidity,AgSeniorityLevel}=useAppSelector((state)=>state.appConfig)
  const [togglePopup, setTogglePopup] = useState(false);
  const [viewAgreementPopup, setViewAgreementPopup] = useState(false);
  const [viewNDAPopup, setViewNDAPopup] = useState(false);
  const imageInputRef = useRef(null);
  const ndaInputRef = useRef(null);
  const dispatch = useAppDispatch();


  const {defaultRange,defaultEngagementType,defaultAgPaymentTerms,defaultAgPaymentSchedule,defaultAgFreeReplacementPeriod,defaultAgSeniorityLevel,defaultAgProfileValidity}=useSalesDropdown()
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const res = await dispatch(getAgreementByIdApi({ clientId, agreementId })).then(unwrapResult);
    setAgreementData(res.data);
  };

  const togglePopupHandler = () => {
    setTogglePopup(!togglePopup);
  };

  const toggleAgreementPopupHandler = () => {
    setViewAgreementPopup(!viewAgreementPopup);
  };

  const toggleNDAPopupHandler = () => {
    setViewNDAPopup(!viewNDAPopup);
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    const toastId = toast.loading("Uploading...");
    if(!files.length){
      return
    }
    uploadContent.uploadCRMSContent(session.userId, e.target.files,async(response) => {
      setAgreementData({...agreementData,agreementFile:response[0]?.url})
      dispatch(updateAgreementApi({clientId,agreementId,agreementFile:response[0]?.url,ctcRange: agreementData?.ctcRange,seniorityLevels: agreementData?.seniorityLevels}))
      toast.dismiss(toastId);
    });
  };

  const handleNDAFileChange = (e) => {
    const files = e.target.files;
    const toastId = toast.loading("Uploading...");
    if(!files.length){
      return
    }
    uploadContent.uploadCRMSContent(session.userId, e.target.files,async(response) => {
      setAgreementData({...agreementData,NDAFile:response[0]?.url,nonDisclosureAgreement:"Yes"})
      dispatch(updateAgreementApi({clientId,agreementId,NDAFile:response[0]?.url,ctcRange: agreementData?.ctcRange,seniorityLevels: agreementData?.seniorityLevels,nonDisclosureAgreement:"Yes"}))
      toast.dismiss(toastId);
    });
  };

  return (
    <>
      <div className="h-[80vh] w-[60vw]  bg-white  rounded-2xl overflow-auto">
        <div className="flex gap-4 items-center mb-6">
          <h2 className="text-4xl font-semibold text-gray-800">Agreement Details</h2>
          <div
            onClick={togglePopupHandler}
            className="p-2  hover:bg-primary-500/20 rounded-full cursor-pointer"
          >
            <EditIcon width='24' height='24' />
          </div>
        </div>


        <div className='grid grid-cols-2 gap-2 border border-black p-4'>
            <p>
              <span className="font-semibold text-gray-800">Agreement ID:</span> {agreementData?.id}
            </p>
            <p>
              <span className="font-semibold text-gray-800">Agreement Type:</span> {defaultEngagementType(agreementData?.agreementType)}
            </p>
           
            <p>
              <span className="font-semibold text-gray-800">Start Date:</span> {new Date(agreementData?.agreementStartDate).toLocaleDateString()}
            </p>
            <p>
              <span className="font-semibold text-gray-800">End Date:</span> {agreementData?.agreementEndDate.startsWith("0001-01-01")?"Till termination":new Date(agreementData?.agreementEndDate).toLocaleDateString()}
            </p>
            <p>
              <span className="font-semibold text-gray-800">New or Renew:</span> {agreementData?.newOrRenew}
            </p>
            <p className='flex items-center gap-2'>
              <span className=" font-semibold text-gray-800">Non-Disclosure Agreement:</span> {agreementData?.nonDisclosureAgreement=="Yes"?<span onClick={toggleNDAPopupHandler}><FileIcon/></span>:
              <span>No {" "}<span onClick={() => ndaInputRef.current.click()} className='text-xs bg-primary-500 px-2 py-0.5 rounded-lg text-white cursor-pointer'>Add File</span></span>}
                  { !agreementData?.NDAFile &&  <input
                    ref={ndaInputRef}
                    type="file"
                    name="NDAFile"
                    accept=".pdf,.doc,.docx"
                    onChange={handleNDAFileChange}
                    className="hidden "
                  />}
            </p>
        </div>

        <div className='grid grid-cols-2 gap-2 border border-black mt-4  p-4'>
            <p>
              <span className="font-semibold text-gray-800">Payment Terms:</span> {defaultAgPaymentTerms(agreementData?.paymentTerms)}
            </p>
            <p>
              <span className="font-semibold text-gray-800">Late Payment Clause:</span> {agreementData?.latePaymentClause}
            </p>
            <div className='col-span-2 flex items-center gap-4'>
              <label className="font-semibold text-gray-800"> Payment Schedule:</label>
              <div className=' flex flex-col  flex-wrap border w-2/3'>
             
                {agreementData?.paymentSchedules.map((ele)=>{
                  return (
                    <div className='flex border border-exgray-200'>
                    <span className="  p-1 flex-1 "> {defaultAgPaymentSchedule(ele.scheduleType) }</span>
                    <span className="  p-1 border-l border-exgray-200 "> {ele.value} {ele.type=="amount"?"Rs":"%"}</span>
                  </div>
                  )
                })}
             
              </div>
            </div>   
        </div>

        <div className='grid grid-cols-2 gap-2 border border-black mt-4 p-4'>
           <p>
              <span className="font-semibold text-gray-800">Free Replacement Period:</span> {defaultAgFreeReplacementPeriod(agreementData?.freeReplacementPeriod)} 
            </p>
            <p>
              <span className="font-semibold text-gray-800">Conditions for Replacement:</span> {agreementData?.conditionForReplacement || "No conditions provided"}
            </p>
            <p>
              <span className="font-semibold text-gray-800">Profile Validity:</span> {defaultAgProfileValidity(agreementData?.profileValidity)} 
            </p>
            <p>
              <span className="font-semibold text-gray-800">Total Revenue from Agreement:</span> ₹{agreementData?.totalRevenueFromAgreement}
            </p>
            <p>
              <span className="font-semibold text-gray-800">Bonus Commission:</span> ₹{agreementData?.bonusCommission || 0}
            </p>
        </div>

        <div className="grid grid-cols-2 gap-2  p-4">
            <p className='flex gap-2 items-center'>
              <span  className="font-semibold text-gray-800 text-nowrap">Agreement File: </span> 
              
              {agreementData?.agreementFile?<span className="cursor-pointer" onClick={toggleAgreementPopupHandler}> <FileIcon/> </span>
              :<span>"No file provided" <span onClick={() => imageInputRef.current.click()} className='text-xs bg-primary-500 px-2 py-0.5 rounded-lg text-white cursor-pointer'>Add File</span></span>}
              
            </p>
          { !agreementData?.agreementFile &&  <input
            ref={imageInputRef}
            type="file"
            name="agreementFile"
            accept=".pdf,.doc,.docx"
            onChange={handleFileChange}
            className="hidden "
          />}
            {/* <div className="w-fit mx-auto pt-2">
                <Pdf
                  src={`${baseUrl}/${agreementData?.agreementFile}?t=${session.token}`}
                />
              </div> */}
        </div>


        <div>
      
           {agreementData?.ctcRange?.domestic && agreementData?.ctcRange?.domestic[0]?.minRange &&  <div className="mb-8">
                <h2 className="text-lg font-bold text-gray-800 my-2">CTC Range :</h2>

                {["domestic", "international"].map((type) => (
                  <>
                 
                 { agreementData?.ctcRange[type][0]?.minRange &&  <div key={type} className="mb-2 ml-10">
                    <h3 className="text-md font-semibold mb-2 capitalize text-blue-700">{type} Rates</h3>
                    <table className="table-auto border-collapse border border-gray-300 w-full">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="border border-gray-300 px-4 py-2">Min Range</th>
                          <th className="border border-gray-300 px-4 py-2">Max Range</th>
                          <th className="border border-gray-300 px-4 py-2">Input Type</th>
                          <th className="border border-gray-300 px-4 py-2">Value</th>
                          <th className="border border-gray-300 px-4 py-2">CTC Type</th>
                        </tr>
                      </thead>
                      <tbody className='text-center'>
                        {agreementData?.ctcRange[type].map((entry, index) => (
                          <tr key={index}>
                            <td className="border border-gray-300 px-4 py-2">{defaultRange(entry.minRange)}</td>
                            <td className="border border-gray-300 px-4 py-2">{defaultRange(entry.maxRange)}</td>
                            <td className="border border-gray-300 px-4 py-2 capitalize">{entry.inputType}</td>
                            <td className="border border-gray-300 px-4 py-2">
                              {entry.inputType === "amount" ? `₹${entry.amount}` : `${entry.percentage}%`}
                            </td>
                            <td className="border border-gray-300 px-4 py-2 capitalize">{entry.ctcType}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>}
                  </>
                ))}
              </div>}

              {agreementData?.seniorityLevels?.domestic && agreementData?.seniorityLevels?.domestic[0]?.minLevel && <div className="mb-8">
                <h2 className="text-lg font-bold text-gray-800 my-2">Seniority Level :</h2>

                {["domestic", "international"].map((type) => (
                <>
                { agreementData?.seniorityLevels[type][0]?.minLevel &&  <div key={type} className="mb-2 ml-10">
                    <h3 className="text-md font-semibold mb-2 capitalize text-blue-700">{type} Rates</h3>
                    <table className="table-auto border-collapse border border-gray-300 w-full">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="border border-gray-300 px-4 py-2">Seniority Type</th>
                          {/* <th className="border border-gray-300 px-4 py-2">Max Level</th> */}
                          <th className="border border-gray-300 px-4 py-2">Input Type</th>
                          <th className="border border-gray-300 px-4 py-2">Value</th>
                        </tr>
                      </thead>
                      <tbody className='text-center'>
                        {agreementData?.seniorityLevels[type].map((entry, index) => (
                          <tr key={index}>
                            <td className="border border-gray-300 px-4 py-2">{(entry.minLevel)}</td>
                            {/* <td className="border border-gray-300 px-4 py-2">{defaultAgSeniorityLevel(entry.maxLevel)}</td> */}
                            <td className="border border-gray-300 px-4 py-2 capitalize">{entry.inputType}</td>
                            <td className="border border-gray-300 px-4 py-2">
                              {entry.inputType === "amount" ? `₹${entry.amount}` : `${entry.percentage}%`}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>}
                  </>
                )
                )}
              </div>}
        </div>


          {/* <div className="flex  justify-center gap-24  border-black">
            <div className='flex gap-2 flex-col items-center flex-1 '>
           { agreementData?.ctcRange?.domestic[0]?.percentage && <h3 className="text-xl font-semibold text-gray-800 ">CTC Range (Domestic)</h3>}
            {agreementData?.ctcRange?.domestic[0]?.percentage && agreementData?.ctcRange?.domestic.map((item, index) => (
              <div key={index} className=" p-4 bg-gray-100 rounded-lg shadow-sm w-3/5">
                <p>
                  <span className="font-semibold text-gray-800">Range:</span> {item.minRange ? `${defaultRange(item.minRange)} - ${defaultRange(item.maxRange)}` : "N/A"}
                </p>
                <p>
                  <span className="font-semibold text-gray-800">Percentage:</span> {item.percentage}%
                </p>
                <p>
                  <span className="font-semibold text-gray-800">Amount:</span> ₹ {item.amount}
                </p>
              </div>
            ))}
            </div>

            <div className='flex   gap-2 flex-col items-center flex-1'>
              { agreementData?.ctcRange?.international[0]?.percentage &&<h3 className="text-xl  font-semibold text-gray-800 ">CTC Range (International)</h3>}
            {agreementData?.ctcRange?.international.map((item, index) => (
              <>
              
              {item.minRange && <div key={index} className=" p-4 bg-gray-100 rounded-lg shadow-sm w-3/5">
                <p>
                  <span className="font-semibold text-gray-800 ">Range :</span>  {item.minRange ? `${defaultRange(item.minRange)} - ${defaultRange(item.maxRange)}` : "N/A"}
                </p>
                <p>
                  <span className="font-semibold text-gray-800">Percentage:</span> {item.percentage || "N/A"}
                </p>
                <p>
                  <span className="font-semibold text-gray-800">Amount:</span> ₹ {item.amount || "N/A"}
                </p>
              </div>}
              </>
            ))}
            </div>
          </div> */}

             {/* Seniority Levels (Domestic & International) */}
             {/* <div className=" flex  justify-center gap-24  border-black">
                <div className='flex gap-2 flex-col items-center border-black flex-1'>
                {agreementData?.seniorityLevels?.domestic[0]?.percentage && <h3 className="text-xl font-semibold text-gray-800 mt-6">Seniority Levels (Domestic)</h3>}
                {agreementData?.seniorityLevels?.domestic[0]?.percentage && agreementData?.seniorityLevels?.domestic.map((item, index) => (
                  <>
                 
                  {item.minLevel && <div key={index} className=" p-4 bg-gray-100 rounded-lg shadow-sm w-3/5">
                    <p>
                      <span className="font-semibold text-gray-800">Level:</span> {item.minLevel ? `${defaultAgSeniorityLevel(item.minLevel)} - ${defaultAgSeniorityLevel(item.maxLevel)}` : "N/A"}
                    </p>
                    <p>
                      <span className="font-semibold text-gray-800">Percentage:</span> {item.percentage || "N/A"}
                    </p>
                    <p>
                      <span className="font-semibold text-gray-800">Amount:</span> ₹{item.amount || "N/A"}
                    </p>
                  </div>}
                  </>
                ))}
                </div>

              <div className='flex flex-col items-center gap-2 flex-1'>
              { agreementData?.seniorityLevels?.international[0]?.percentage && <h3 className="text-xl font-semibold text-gray-800 mt-6">Seniority Levels (International)</h3>}
                { agreementData?.seniorityLevels?.international[0]?.percentage && agreementData?.seniorityLevels?.international.map((item, index) => (
                  <div key={index} className=" p-4 bg-gray-100 rounded-lg shadow-sm  w-3/5">
                    <p>
                      <span className="font-semibold text-gray-800">Level:</span> {item.minLevel ? `${defaultAgSeniorityLevel(item.minLevel)} - ${defaultAgSeniorityLevel(item.maxLevel)}` : "N/A"}
                    </p>
                    <p>
                      <span className="font-semibold text-gray-800">Percentage:</span> {item.percentage || "N/A"}
                    </p>
                    <p>
                      <span className="font-semibold text-gray-800">Amount:</span> ₹ {item.amount || "N/A"}
                    </p>
                  </div>
                ))}
                </div>
          </div> */}
          
      </div>

      <Popup
        visible={togglePopup}
        onClose={togglePopupHandler}
        outsideClickClose={false}
        isCloseButton={true}
        children={
          <ServiceAgreementForm
            update={true}
            agreementUpdatedData={agreementData}
            togglePopupHandler={togglePopupHandler}
            agreementPopupHandler={agreementPopupHandler}
       />
        }
      />
     

       <Popup
        visible={viewAgreementPopup}
        onClose={()=>setViewAgreementPopup(!viewAgreementPopup)}
        isCloseButton={true}
        // children={<PdfView src={`${baseUrl}/${agreementData?.agreementFile}?t=${session.token}` }/>}
        children={<DocToImageViewer docUrl={`${baseUrl}/${agreementData?.agreementFile}?t=${session.token}` }/>}
        />

      <Popup
        visible={viewNDAPopup}
        onClose={()=>setViewNDAPopup(!viewNDAPopup)}
        isCloseButton={true}
        // children={<PdfView src={`${baseUrl}/${agreementData?.NDAFile}?t=${session.token}` } />}
        children={<DocToImageViewer docUrl={`${baseUrl}/${agreementData?.NDAFile}?t=${session.token}` } />}
          />
    
    </>
  );
};

export default AgreementDetail;

